import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AttendeeRow } from '../attendance.dialog';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AttendeeRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Id', row => row.accEntrepreneurId, { header: 'accEntrepreneurId' }),
		buildColumn(util, 'Id', row => row.accSessionAttendeeId, { header: 'accSessionAttendeeId' }),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.cityAndState, { header: 'Location', hidden: true }),
		buildColumn(util, 'Number', row => row.zip, { header: 'ZipCode', hidden: true }),
		buildColumn(util, 'Text', row => row.business, { header: 'Venture' }),
		buildColumn(util, 'YesNo', row => row.droppedOut, { header: 'Dropped Out', hidden: true }),
		buildColumn(util, 'Text', row => row.attended, { header: 'Attended' }),
		buildColumn(util, 'YesNo', row => row.survey, { header: 'Survey Response' }),
		buildColumn(util, 'Phone', row => row.phone, { header: 'Phone', hidden: true }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email', hidden: true }),
		buildColumn(util, 'FirstName', row => row.firstName, { header: 'First', hidden: true }),
		buildColumn(util, 'LastName', row => row.lastName, { header: 'Last', hidden: true }),
	];


	return columns;

}